/**
 * APP-1719: NeuroPace standardizes on a single `allocated`, the value TB Real uses,
 * instead of the two group statuses.
 *
 * Studies keyed on the Auth0 organization name (`user.org_name`). Studies not listed
 * here keep `allocated_group_2` / `allocated_group_3`; the backend accepts all three,
 * so which a study offers is decided here rather than through per-study config.
 */
export const SINGLE_ALLOCATED_STATUS_STUDIES = ['aspen-neuropace-aurora-central']

export const ALLOCATED_GROUP_STATUSES = ['allocated_group_2', 'allocated_group_3']

export const usesSingleAllocatedStatus = (orgName: string | null | undefined): boolean =>
    Boolean(orgName && SINGLE_ALLOCATED_STATUS_STUDIES.includes(orgName))

/**
 * Whether a study offers this status.
 *
 * A study on the single `allocated` drops the two group options; every other study
 * drops `allocated`, so it is not offered a value its coordinators do not recognise.
 */
export const studyOffersStatus = (status: string, orgName: string | null | undefined): boolean =>
    usesSingleAllocatedStatus(orgName) ? !ALLOCATED_GROUP_STATUSES.includes(status) : status !== 'allocated'

/** Drop the status options a study does not use, for `{ value }` shaped lists. */
export const filterAllocatedStatusOptions = <T extends { value: string }>(options: T[], orgName: string | null | undefined): T[] =>
    options.filter((option) => studyOffersStatus(option.value, orgName))

/**
 * The same rule for a plain list of status values.
 *
 * The candidate filter drawer takes its statuses straight from the API, which serves
 * all three allocated variants because the backend accepts all three. Without this it
 * offered NeuroPace the group statuses it can no longer set, and every other study an
 * `Allocated` it does not use.
 */
export const filterAllocatedStatusValues = (statuses: string[], orgName: string | null | undefined): string[] =>
    statuses.filter((status) => studyOffersStatus(status, orgName))
